// API-Konfiguration für das Newsletter-System

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7071';

export const API_ENDPOINTS = {
  newsletters: `${API_BASE_URL}/api/newsletter`,
  subscribers: `${API_BASE_URL}/api/subscribers`,
  optOut: `${API_BASE_URL}/api/subscribers/opt-out`,

  interestSuggestions: `${API_BASE_URL}/api/interests/suggestions`,

  altchaChallenge: `${API_BASE_URL}/api/altcha/challenge`,
  altchaVerify: `${API_BASE_URL}/api/altcha/verify`
} as const;

export default API_ENDPOINTS;
